import { type AxiosError } from 'axios'
import { AppError } from '../../classes/AppError'

const DEFAULT_MESSAGE = 'AXIOS ERROR - Unexpected error has ocurred'

export function convertAxiosErrorToAppError(error: AxiosError): AppError {
  const { response } = error
  const data = response?.data
  const errors =
    data && typeof data === 'object' && 'errors' in data && Array.isArray(data.errors)
      ? data.errors
      : undefined

  return new AppError({
    message: typeof data === 'string' ? data : DEFAULT_MESSAGE,
    status: response?.status,
    errors,
  })
}
